var _defs, _path, _path2, _path3, _circle, _use, _use2, _use3, _use4, _path4, _path5, _use5, _use6, _use7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGd = function SvgGd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 640 480"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", {
    id: "gd_svg__c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gd_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "gd_svg__a",
    fill: "#fcd116",
    d: "M0-1v1h.5",
    transform: "rotate(18 0 -1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gd_svg__a",
    transform: "scale(-1 1)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gd_svg__b",
    transform: "rotate(72)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gd_svg__b",
    transform: "rotate(144)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gd_svg__b",
    transform: "rotate(216)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gd_svg__b",
    transform: "rotate(288)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ce1126",
    d: "M0 0h640v480H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#007a5e",
    d: "M67.2 67.2h505.6v345.6H67.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "M67.2 67.3h505.6L67.2 412.9h505.6z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 319.9,
    cy: 240.1,
    r: 57.6,
    fill: "#ce1126"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gd_svg__c",
    width: "100%",
    height: "100%",
    transform: "translate(320 240)scale(52.8)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gd_svg__d",
    width: "100%",
    height: "100%",
    x: -100,
    transform: "translate(-30.3)"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gd_svg__c",
    id: "gd_svg__d",
    width: "100%",
    height: "100%",
    transform: "translate(320 33.6)scale(31.2)"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gd_svg__d",
    width: "100%",
    height: "100%",
    x: 100,
    transform: "translate(30.3)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ce1126",
    d: "M102.3 240.7a80 80 0 0 0 33.5 33.2 111 111 0 0 0-11.3-45z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "M90.1 194.7c10.4 21.7-27.1 73.7 35.5 85.9a63 63 0 0 1-10.9-41.9 70 70 0 0 1 32.5 30.8c16.4-59.5-42-55.8-57.1-74.8"
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gd_svg__d",
    width: "100%",
    height: "100%",
    x: -100,
    transform: "translate(-30.3 414.6)"
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gd_svg__c",
    width: "100%",
    height: "100%",
    transform: "translate(320 448.2)scale(31.2)"
  })), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gd_svg__d",
    width: "100%",
    height: "100%",
    x: 100,
    transform: "translate(30.3 414.6)"
  })));
};
export default SvgGd;